import { styled } from "goober";
import {
  normalizeRouteAuth,
  type RouteAuthMode,
} from "../../shared/monitoringRouteAuth";
import { draftRouteAuth } from "../../shared/stepConfig";
import { routeAuthDescription, routeAuthLabel } from "../lib/routeAuthDisplay";
import { Icon, type IconName } from "./Icon";
import { Tooltip } from "./Tooltip";

const ROUTE_AUTH_ICONS: Record<RouteAuthMode, IconName> = {
  public: "earth",
  external_id: "link-2",
  tenant: "building-2",
  sso: "key",
  connected_app: "plug",
  space: "lock",
};

const AccessIcon = styled("span")`
  display: flex;
  flex-shrink: 0;
`;

export function BrowserAccess({
  routeAuth,
  routeGroups,
  draft,
}: {
  routeAuth: string | null | undefined;
  routeGroups?: readonly string[] | null;
  draft: boolean;
}) {
  const liveAuth = normalizeRouteAuth(routeAuth);
  const liveGroups = liveAuth === "sso" ? (routeGroups ?? []) : [];
  const auth = draft ? normalizeRouteAuth(draftRouteAuth(liveAuth)) : liveAuth;
  const groups = auth === "sso" ? liveGroups : [];

  return (
    <Tooltip
      content={
        auth === liveAuth
          ? routeAuthDescription(auth, groups)
          : `This draft is only visible to members of the workflow’s space. Once pushed live: ${routeAuthDescription(liveAuth, liveGroups)}`
      }
    >
      <AccessIcon aria-label={routeAuthLabel(auth, groups)}>
        <Icon
          name={ROUTE_AUTH_ICONS[auth]}
          size={12}
          color="var(--text-secondary)"
        />
      </AccessIcon>
    </Tooltip>
  );
}
